export const FAQS_URL =
  'https://docs.helixpay.ph/docs/frequently-asked-questions-faqs';
